<template>
  <div>
    <div class="card-carousel-wrapper">
      <div class="card-carousel--nav__left" @click="moveCarousel(-1)" :disabled="atHeadOfList"></div>

      <div class="card-carousel">
        <div class="card-carousel--overflow-container">
          <div class="card-carousel-cards" :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
            <div class="card-carousel--card" v-for="user in users" :key="user.id">
              <CardUserChartMobile
                :user="user"
                widthCard="150"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="card-carousel--nav__right" @click="moveCarousel(1)" :disabled="atEndOfList"></div>
    </div>
  </div>
</template>
<script>
import CardUserChartMobile from '@/components/User/CardUserChartMobile'

export default {
  components: {
    CardUserChartMobile
  },
  props: {
    users: { type: Array, required: true },
  },
  data() {
    return {
      currentOffset: 0,
      windowSize: 1,
      paginationFactor: 170,
    };
  },
  computed: {
    atEndOfList() {
      return (
        this.currentOffset <=
        this.paginationFactor * -1 * (this.users.length - this.windowSize)
      );
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
  methods: {
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
  },
};
</script>
<style lang="scss">
$vue-navy: #2c3e50;
$vue-navy-light: #3a5169;
$vue-teal: #42b883;
$vue-teal-light: #42b983;
$gray: #666a73;
$light-gray: #f8f8f8;

body {
  background: $light-gray;
  color: $vue-navy;
  font-family: "Source Sans Pro", sans-serif;
}

.card-carousel-wrapper {
  display: flex;
  // align-items: center;
  justify-content: center;
  margin-left: 10px;
  color: $gray;
}

.card-carousel {
  display: flex;
  justify-content: center;
  width: 320px;

  &--overflow-container {
    overflow: hidden;
  }

  &--nav__left,
  &--nav__right {
    display: inline-block;
    width: 15px;
    height: 15px;
    padding: 7px;
    box-sizing: border-box;
    border-top: 2px solid $vue-navy;
    border-right: 2px solid $vue-navy;
    cursor: pointer;
    margin: 0 5px;
    margin-top: 2.7rem;
    transition: transform 150ms linear;
    &[disabled] {
      opacity: 0.2;
      border-color: black;
    }
  }

  &--nav__left {
    transform: rotate(-135deg);
    &:active {
      transform: rotate(-135deg) scale(0.9);
    }
  }

  &--nav__right {
    transform: rotate(45deg);
    &:active {
      transform: rotate(45deg) scale(0.9);
    }
  }
}

.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);

  .card-carousel--card {
    margin: 0 10px;
    cursor: pointer;
    // box-shadow: 0 4px 15px 0 rgba(40, 44, 53, 0.06),
      // 0 2px 2px 0 rgba(40, 44, 53, 0.08);
    background-color: #fff;
    border-radius: 4px;
    z-index: 3;
    margin-bottom: 2px;

    &:first-child {
      margin-left: 1px;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

@media screen and (min-width: 300px) and (max-width: 325px) {
  .card-carousel {
    width: 250px;
  }
}

@media screen and (min-width: 326px) and (max-width: 360px) {
  .card-carousel {
    width: 300px;
  }
}
</style>